<template>
  <section>
    <!--工具条-->
    <div class="searchBox">
      <el-input
        size="mini"
        v-model="Title"
        @blur="inputChange"
        placeholder="输入视频名称"
        :style="{ width: '200px' }"
      />

      <el-select
        size="mini"
        v-model="VideoCateId"
        @change="inputChange"
        placeholder="请选择视频分类"
      >
        <el-option
          v-for="item in videocate"
          :key="item.Id"
          :label="item.Name"
          :value="item.Id"
        ></el-option>
      </el-select>

      <el-select
        size="mini"
        v-model="isPub"
        @change="inputChange"
        placeholder="请选择是否上架"
      >
        <el-option
          v-for="item in statusList"
          :key="item.value"
          :label="item.LinkUrl"
          :value="item.value"
        ></el-option>
      </el-select>

      <!-- <el-button style="background-color: #5474e6; color: #ffffff" size="mini"
        >查询</el-button
      > -->
      <el-button type="primary" @click="AddVideo" size="mini">新增</el-button>
      <el-button
        type="success"
        size="mini"
        @click="AdminUpdatePubInfo(true)"
        :disabled="this.sels.length === 0"
        >批量上架</el-button
      >
      <el-button
        type="danger"
        size="mini"
        @click="AdminUpdatePubInfo(false)"
        :disabled="this.sels.length === 0"
        >批量下架</el-button
      >
    </div>

    <!--列表-->
    <el-table
      :data="cartoonmain"
      highlight-current-row
      height="500"
      v-loading="listLoading"
      @selection-change="selsChange"
      style="width: 100%"
    >
      <el-table-column type="selection" width="50"></el-table-column>
      <!-- <el-table-column type="index" width="80"></el-table-column> -->
      <el-table-column
        prop="CateName"
        label="分类名"
        sortable
      ></el-table-column>
      <el-table-column prop="Title" label="标题" sortable></el-table-column>
      <el-table-column
        prop="Author"
        label="作者"
        width="150"
        sortable
      ></el-table-column>
      <el-table-column prop="Summary" label="描述" sortable>
        <template slot-scope="scope">
          <el-popover
            placement="top-start"
            title="描述"
            width="200"
            trigger="hover"
            :content="scope.row.Summary"
          >
            <p slot="reference" class="popoverClass">{{ scope.row.Summary }}</p>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="图片" width="100" sortable>
        <template slot-scope="scope">
          <el-image
            style="width: 50px; height: 50px"
            :src="scope.row.CoverImgUrl"
            :preview-src-list="[scope.row.CoverImgUrl]"
            fit="cover"
          ></el-image>
        </template>
      </el-table-column>

      <el-table-column
        prop="CreateTime"
        label="创建时间"
        :formatter="formatCreateTime"
        width="150"
        sortable
      ></el-table-column>
      <el-table-column label="操作" sortable width="100">
        <template slot-scope="scope">
          <!-- <el-button type="text" style="color: red" @click="delectFn(scope.row)"
            >删除</el-button
          > -->
          <el-button type="text" @click="handleEdit(scope.row)">修改</el-button>
        </template>
      </el-table-column>
      <el-table-column label="状态" sortable width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.IsPub" type="success">已上架</el-tag>
          <el-tag type="info" v-else>已下架</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="prev, pager, next,sizes"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :page-size="pageSize"
        :page-sizes="[10, 20, 50, 100, 200, 300, 400]"
        :total="total"
        style="float: right"
      ></el-pagination>
    </el-col>

    <!--新增界面-->
    <el-dialog
      :title="updateId ? '修改' : '新增'"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="addForm" label-width="80px" ref="addForm">
        <el-form-item label="视频分类" prop="title">
          <el-select
            size="mini"
            v-model="addForm.muVideoCateId"
            placeholder="请选择视频分类"
          >
            <el-option
              v-for="item in videocateAddList"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="addForm.title" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="作者" prop="title">
          <el-input v-model="addForm.author" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="简介" prop="title">
          <el-input
            type="textarea"
            :autosize="{
              minRows: 2,
            }"
            v-model="addForm.summary"
            auto-complete="off"
          ></el-input>
        </el-form-item>

        <el-form-item label="上传封面">
          <el-upload
            class="avatar-uploader"
            action="/api/Img/UploadImage/"
            :headers="token"
            :show-file-list="false"
            width="380"
            :on-success="handleAvatarSuccessAdd"
            :before-upload="beforeAvatarUpload"
          >
            <img
              v-if="addForm.coverImgUrl"
              :src="addForm.coverImgUrl"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="时长" prop="title">
          <el-input-number
            v-model="addForm.duration"
            auto-complete="off"
            :min="0"
            :precision="2"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="上传视频">
          <el-upload
            class="avatar-uploader"
            action="/api/Img/UploadFile"
            :headers="token"
            :show-file-list="false"
            width="380"
            :on-success="handleAvatarSuccessAddVideo"
            :before-upload="beforeAvatarUploadVideo"
            :on-progress="videoProgress"
          >
            <video
              v-if="addForm.muUrl"
              :src="addForm.muUrl"
              class="avatar"
              autoplay
            ></video>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <el-progress
            :percentage="plan"
            style="width: 300px"
            v-if="plan"
          ></el-progress>
        </el-form-item>
        <el-form-item label="是否上架" prop="IsPub">
          <el-radio-group v-model="addForm.isPub">
            <el-radio :label="false">否</el-radio>
            <el-radio :label="true">是</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import { quillEditor } from "vue-quill-editor"; //调用编辑器
// require styles
// import "quill/dist/quill.core.css";
// import "quill/dist/quill.snow.css";
// import "quill/dist/quill.bubble.css";
// import {
//   addMuVideo,
//   updateMuVideo,
//   getMuVideoPage,
//   getMuVideosingle,
//   deleteMuVideo,
//   getcategoryselect,
//   GetAdminVideoCateList,
// } from "../../api/api";
// import { getButtonList } from "../../promissionRouter";
// import store from "../../store";

import {
  AdminGetVideoCateList,
  AdminGetVideoByPage,
  AdminAddVideoInfo,
  AdminGetOneInfo,
  AdminUpdateVideoInfo,
  AdminUpdatePubInfo,
} from "@/api/api";
export default {
  components: {
    // Toolbar, //使用编辑器
    quillEditor,
  },

  data() {
    return {
      Title: "",
      VideoCateId: "0",
      plan: 0, //进度
      token: {
        Authorization: "Bearer ",
      },
      updateId: "",
      isPub: 0,
      videocate: [],
      videocateAddList: [],
      cartoonmain: [],
      statusList: [
        { LinkUrl: "已上架", value: 1 },
        { LinkUrl: "已下架", value: 2 },
        { LinkUrl: "全部上下架视频", value: 0 },
      ],
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      sels: [], //列表选中列

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      //新增界面数据
      addForm: {
        muVideoCateId: "",
        title: "",
        author: "",
        summary: "",
        coverImgUrl: "",
        cateId: 1,
        isPub: true,
        duration: 0,
        muUrl: "",
      },
    };
  },
  methods: {
    AddVideo() {
      this.addFormVisible = true;
      this.addForm = {
        muVideoCateId: "",
        title: "",
        author: "",
        summary: "",
        coverImgUrl: "",
        cateId: 1,
        isPub: true,
        duration: 0,
        muUrl: "",
      };
    },
    selsChange: function (sels) {
      this.sels = sels;
    },

    handleAvatarSuccessAdd(res) {
      if (res.success) {
        this.addForm.coverImgUrl = res.response;
      } else {
        this.$message({
          message: "上传失败，请重试",
          type: "error",
        });
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        this.$message.error("上传图片只能是 JPG或png 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return (isJPG || isPNG) && isLt2M;
    },

    handleAvatarSuccessAddVideo(res) {
      //console.log(res);
      if (res.success) {
        this.addForm.muUrl = res.response;
        this.plan = 100;
        setTimeout(() => {
          this.plan = 0;
        }, 200);
      } else {
        this.plan = 0;
        this.$message({
          message: "上传失败，请重试",
          type: "error",
        });
      }
    },
    beforeAvatarUploadVideo(file) {
      let type = file.type.split("/");
      if (file.size > 1024 * 1024 * 200) {
        this.$message.warning("请保持在200M以内");
        return false;
      }
      if (type[0] == "video") {
        return true;
      } else {
        this.$message.warning("请上传视频");
        return false;
      }
    },
    videoProgress(e) {
      ;
      this.plan = Math.ceil((e.percent / e.total) * 100);
      if (this.plan >= 100) {
        setTimeout(() => {
          this.plan = 0;
        }, 200);
      }
    },
    //性别显示转换
    formatEnabled: function (row, column) {
      return row.Enabled ? "正常" : "未知";
    },
    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(new Date(row.CreateTime), "yyyy-MM-dd");
    },
    handleSizeChange(value) {
      this.page = 1;
      this.pageSize = value;
      this.getMainlist();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getMainlist();
    },
    inputChange() {
      this.page = 1;

      this.getMainlist();
    },
    //获取视频列表
    async getMainlist() {
      let para = {
        PageIndex: this.page,
        PageSize: this.pageSize,
        VideoCateId: this.VideoCateId ? this.VideoCateId : undefined,
        Title: this.Title ? this.Title : undefined,
        isPub: this.isPub,
      };
      this.listLoading = true;
      let xhr = await AdminGetVideoByPage(para);
      if (xhr.data.success) {
        this.total = xhr.data.response.dataCount;
        this.cartoonmain = xhr.data.response.data;
        this.listLoading = false;
      } else {
        this.cartoonmain = [];
        this.listLoading = false;
      }
    },

    onEditorReady(editor) {},
    //显示编辑界面
    handleEdit(row) {
      this.updateId = row.Id;
      this.addFormVisible = true;
      let para = { Id: row.Id };
      AdminGetOneInfo(para).then((res) => {
        this.addForm.muVideoCateId = res.data.response.MuVideoCateId;
        this.addForm.title = res.data.response.Title;
        this.addForm.author = res.data.response.Author;
        this.addForm.summary = res.data.response.Summary;
        this.addForm.isPub = res.data.response.IsPub;
        this.addForm.duration = res.data.response.Duration;
        this.addForm.muUrl = res.data.response.MuUrl;
        this.addForm.coverImgUrl = res.data.response.CoverImgUrl;
      });
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.updateId = "";
      this.addForm = {
        Id: "",
        CId: "",
        title: "",
        Summary: "",
        suitableAge: "",
        coverImgUrl: "",
        IsPub: false,
        price: 0,
        iosPrice: 0,
        OrderSort: 0,
      };
    },

    //新增
    addSubmit: function () {
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(async () => {
            this.addLoading = true;

            if (!this.updateId) {
              let xhr = await AdminAddVideoInfo(this.addForm);
              if (xhr.data.success) {
                this.addLoading = false;
                this.$message({
                  message: xhr.data.msg,
                  type: "success",
                });
                this.addFormVisible = false;
                this.getMainlist();
              } else {
                this.$message({
                  message: xhr.data.msg,
                  type: "error",
                });
              }
            } else {
              let para = {
                ...this.addForm,
                id: this.updateId,
              };
              let xhr = await AdminUpdateVideoInfo(para);
              if (xhr.data.success) {
                this.addLoading = false;
                this.$message({
                  message: xhr.data.msg,
                  type: "success",
                });
                this.addFormVisible = false;
                this.getMainlist();
              } else {
                this.$message({
                  message: xhr.data.msg,
                  type: "error",
                });
              }
            }
          });
        }
      });
    },

    //批量上下架
    async AdminUpdatePubInfo(value) {
      //console.log(this.sels);
      let ids = [];
      this.sels.forEach((item) => {
        ids.push(item.Id);
      });
      let xhr = await AdminUpdatePubInfo({
        ids: ids,
        isPub: value,
      });
      if (xhr.data.success) {
        this.$message.success(xhr.data.msg);
        this.getMainlist();
      } else {
        this.$message.warning(xhr.data.msg);
      }
    },

    // 获取视频分类
    async AdminGetVideoCateList() {
      let xhr = await AdminGetVideoCateList();
      if (xhr.data.success) {
        this.videocate = [
          {
            Id: "0",
            Name: "所有分类",
          },
        ];
        this.videocate.push(...xhr.data.response);
        this.videocateAddList = xhr.data.response;
      } else {
        this.$message.error(xhr.data.msg);
      }
    },
  },
  mounted() {
    this.AdminGetVideoCateList();
    this.getMainlist();
  },
};
</script>

<style scoped lang="less">
/deep/.el-dialog {
  border-radius: 10px;
  overflow: hidden;
}
/deep/.el-dialog__header {
  background: #f2f5ff;
}
.searchBox {
  div,
  button {
    margin-right: 10px;
  }
  margin-bottom: 20px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 320px;
  height: 180px;
  line-height: 180px;
  text-align: center;
  border: 1px #eee solid;
}
.avatar {
  width: 320px;
  height: 180px;
  display: block;
}
.popoverClass {
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  white-space: nowrap;
}
</style>
